import { csCatalog } from './catalogs';

export const LOCALE_STORAGE_KEY = 'linirio:locale';
export const SUPPORTED_LOCALES = ['en', 'cs'];

const reverseCsCatalog = Object.fromEntries(
  Object.entries(csCatalog).map(([english, czech]) => [czech, english]),
);

function browserLocale() {
  if (typeof navigator === 'undefined') return 'en';
  return String(navigator.language || '').toLowerCase().startsWith('cs') ? 'cs' : 'en';
}

function storedLocale() {
  if (typeof window === 'undefined') return null;
  const value = window.localStorage.getItem(LOCALE_STORAGE_KEY);
  return SUPPORTED_LOCALES.includes(value) ? value : null;
}

let activeLocale = storedLocale() || browserLocale();

export function normalizeLocale(value) {
  return SUPPORTED_LOCALES.includes(value) ? value : 'en';
}

export function getActiveLocale() {
  return activeLocale;
}

export function setActiveLocale(value) {
  activeLocale = normalizeLocale(value);
}

export function getIntlLocale(value = activeLocale) {
  return normalizeLocale(value) === 'cs' ? 'cs-CZ' : 'en-US';
}

function translatePattern(english, locale) {
  if (locale !== 'cs') return english;

  const patterns = [
    [/^(\d+) upcoming \/ (\d+) past$/, '$1 nadcházející / $2 minulých'],
    [/^Connected as (.+)\. New bookings go to the selected calendar\.$/, 'Připojeno jako $1. Nové rezervace se ukládají do vybraného kalendáře.'],
    [/^Accepted (\d+), deduped (\d+), suppressed (\d+)\.$/, 'Přijato $1, duplicit $2, potlačeno $3.'],
    [/^Page (\d+) of (\d+)$/, 'Strana $1 z $2'],
    [/^(\d+) results?$/, '$1 výsledků'],
    [/^(\d+) users?$/, '$1 uživatelů'],
    [/^(\d+) conversations?$/, '$1 konverzací'],
  ];

  for (const [pattern, replacement] of patterns) {
    if (pattern.test(english)) return english.replace(pattern, replacement);
  }
  return english;
}

export function translateText(value, locale = activeLocale) {
  if (typeof value !== 'string' || !value) return value;
  const normalizedLocale = normalizeLocale(locale);
  const leading = value.match(/^\s*/)?.[0] || '';
  const trailing = value.match(/\s*$/)?.[0] || '';
  const phrase = value.trim();
  if (!phrase) return value;

  const english = reverseCsCatalog[phrase] || phrase;
  const translated = normalizedLocale === 'cs'
    ? (csCatalog[english] || translatePattern(english, normalizedLocale))
    : english;
  return `${leading}${translated}${trailing}`;
}

export function localizeApiError(value, locale = activeLocale) {
  const raw = typeof value === 'string' ? value.trim() : '';
  if (normalizeLocale(locale) === 'en') {
    return raw || 'Something went wrong. Please try again.';
  }
  if (!raw) return csCatalog['Something went wrong. Please try again.'];
  const direct = csCatalog[raw];
  if (direct) return direct;
  const prefixMatch = Object.keys(csCatalog).find((key) => raw.startsWith(`${key}:`));
  if (prefixMatch) return `${csCatalog[prefixMatch]}${raw.slice(prefixMatch.length)}`;
  return 'Něco se pokazilo. Zkuste to prosím znovu.';
}

export function detectInitialLocale() {
  return storedLocale() || browserLocale();
}
